// extracted by mini-css-extract-plugin
export default {"row":"menu_row__s5vBo","column":"menu_column__IYjFX","subColumn":"menu_subColumn__lH2hN","innerColumn":"menu_innerColumn__FZlSX"};